import * as React from "react";

import { ProductBackendName } from "Components/Features/CheckPrice/Products/productTypes";
import { NumericInput } from "Components/Form/Input";
import { InputMode } from "Components/Form/Input/inputTypes";
import { RadioButtonTrueFalse } from "Components/Form/RadioButton";
import { RecentDamages } from "Components/Form/RecentDamages";
import { VALUE_TYPE } from "Components/NumberValue";
import { useComponentTexts } from "Store/texts/hooks";
import { TextLanguage } from "Store/texts/interfaces";
import { getError } from "Utils/productUtils";
import { FormikProps } from "formik";
import { CaravanTexts } from "../interface";
import { CaravanProductDetailsFormValues } from "./interfaces";

interface Props {
  readonly formProps: FormikProps<CaravanProductDetailsFormValues>;
  readonly texts: CaravanTexts["formText"]["checkPrice"];
  readonly lang: TextLanguage;
}

export const FormElements = (props: Props): React.ReactElement => {
  const { formProps, texts, lang } = props;
  const [{ boolean }] = useComponentTexts();

  return (
    <>
      <RadioButtonTrueFalse
        id="fixedPlace"
        name="fixedPlace"
        label={texts.fixedPlace.label[lang]}
        hint={texts.fixedPlace.hint?.[lang]}
        error={getError("fixedPlace", formProps)}
        options={[
          { id: "yes", label: boolean["yes"][lang], value: true },
          { id: "no", label: boolean["no"][lang], value: false },
        ]}
      />
      <NumericInput
        id="coverageAmount"
        name="coverageAmount"
        label={texts.coverageAmount.label[lang]}
        placeholder={texts.coverageAmount.placeholder?.[lang]}
        hint={texts.coverageAmount.hint?.[lang]}
        suffix={VALUE_TYPE.NOK}
        error={getError("coverageAmount", formProps)}
        inputMode={InputMode.NUMERIC}
        large
      />
      <RecentDamages
        formProps={formProps}
        productName={ProductBackendName.CARAVAN}
      />
    </>
  );
};
